export default "__VITE_ASSET__B8O6pHQR__"